require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconScaleUp.tsx
var IconScaleUp_exports = {};
__export(IconScaleUp_exports, {
  default: () => IconScaleUp_default
});
module.exports = __toCommonJS(IconScaleUp_exports);

// src/assets/monochrome/scaleUp.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgScaleUp = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.8996 2C18.8996 1.50294 18.4967 1.1 17.9996 1.1L11.9996 1.1C11.5026 1.1 11.0996 1.50294 11.0996 2C11.0996 2.49705 11.5026 2.9 11.9996 2.9L15.8268 2.9L11.3632 7.3636C11.0117 7.71507 11.0117 8.28492 11.3632 8.63639C11.7147 8.98787 12.2845 8.98787 12.636 8.63639L17.0996 4.17279V8C17.0996 8.49706 17.5026 8.9 17.9996 8.9C18.4967 8.9 18.8996 8.49706 18.8996 8V2ZM1.09961 18C1.09961 18.4971 1.50255 18.9 1.99961 18.9H7.99961C8.49667 18.9 8.89961 18.4971 8.89961 18C8.89961 17.5029 8.49667 17.1 7.99961 17.1H4.1724L8.63601 12.6364C8.98748 12.2849 8.98748 11.7151 8.63601 11.3636C8.28453 11.0121 7.71469 11.0121 7.36321 11.3636L2.89961 15.8272L2.89961 12C2.89961 11.5029 2.49667 11.1 1.99961 11.1C1.50255 11.1 1.09961 11.5029 1.09961 12L1.09961 18Z", fill: "#676F7E" }) });
var scaleUp_default = SvgScaleUp;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconScaleUp.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconScaleUp = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(scaleUp_default, {}) });
};
IconScaleUp.displayName = "IconScaleUp";
var IconScaleUp_default = IconScaleUp;
